export default __webpack_public_path__ + "static/media/entity-coref-create-coref.d85582ab.gif";